import { render } from "./ContactFormData.vue?vue&type=template&id=3342132e&scoped=true"
import script from "./ContactFormData.vue?vue&type=script&lang=js"
export * from "./ContactFormData.vue?vue&type=script&lang=js"

import "./ContactFormData.vue?vue&type=style&index=0&id=3342132e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/GB-Frontend/GB-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3342132e"]])

export default __exports__